import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { SharedService } from '@shared/services/shared.service';
import { map, Observable } from 'rxjs';
import { API_BASE_DMEPOS_URL } from './config.service';
import { API_BASE_URL} from '@core/index';
import { FaxHistoryForAuth } from '@core/model/fax-history-for-auth';

@Injectable()
export class FaxService{
  constructor(
    private http: HttpClient,
    @Inject(API_BASE_URL) private apiUrl: string,
    private readonly sharedService: SharedService
  ) {}

  getListOfFaxHistoryByAuthorizationNumber(authorizationNumber: string, authorizationDetailId: string): Observable<FaxHistoryForAuth[] | null> {
    const url = `${this.apiUrl}tenants/${this.sharedService.getTenantId()}/Fax/GetFaxHistoriesByAuthorizationDetailId/${authorizationDetailId}?authorizationNumber=${authorizationNumber}`;
    return this.http.get<FaxHistoryForAuth[]>(url);
  }

}
